var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailSales(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 412,
    viewBox: "0 0 412 412",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.818 321C126.295 321 132.949 321.972 139.838 324.943C145.785 327.508 151.205 330.903 156.467 334.599C163.868 339.798 169.698 345.848 173.779 353.865C176.217 358.654 178.006 365.431 176.368 370.655C174.44 376.807 169.144 381.939 162.169 380.855C157.856 380.185 153.903 377.33 150.625 374.643C146.703 371.428 143.564 367.563 140.972 363.27C136.744 356.267 134.26 348.351 130.668 341.033C128.964 337.56 127.317 334.063 125.275 330.762C124.265 329.128 123.189 327.509 121.656 326.294C120.836 325.644 117.378 324.52 118.7 323.061C99.3096 323.315 82.1317 338.207 78.4094 356.641C78.0627 358.359 77.7917 360.091 77.5055 361.82C77.3248 362.911 77.3978 366.937 76.4219 367.634C74.2698 369.172 75.1745 364.499 75.2669 363.826C75.5055 362.087 75.7602 360.35 76.0273 358.615C77.4808 349.181 81.6808 340.411 88.6849 333.683C96.6944 325.99 107.501 321 118.818 321",
    fill: "#C04483"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0866 373.321C70.398 361.231 66.8231 349.169 64.5817 336.698C63.2613 329.349 62.4654 321.932 61.4485 314.537C61.6445 315.434 61.8626 316.327 62.1016 317.214C61.8933 314.966 62.4467 312.479 62.3752 310.177C62.2956 307.611 62.0039 305.039 61.6823 302.496C61.0551 297.533 60.3494 292.597 59.9111 287.609C59.4232 282.052 59.2234 276.463 58.8762 270.894C58.5815 266.167 58.1 261.282 58.3461 256.535C58.4801 253.948 58.433 251.255 58.5291 248.636C58.5614 247.759 58.005 238.379 57.9821 238.389C57.4802 238.614 57.1944 243.022 57.1172 243.686C56.8909 245.624 56.8295 247.562 56.7612 249.508C55.5751 247.765 54.2098 246.151 52.5873 244.787C52.0866 244.366 48.4862 241.219 47.8918 241.486C47.5949 241.619 53.6906 247.875 54.3317 248.377C54.8524 248.785 55.6831 249.225 56.1212 249.711C56.8288 250.495 56.5732 250.334 56.6987 251.271C56.9286 252.989 56.5997 254.919 56.6262 256.656C56.6311 257.587 56.9915 260.66 56.7086 262.235C56.4443 267.329 57.2005 273.056 57.5877 278.247C56.2574 276.207 54.7093 274.359 52.953 272.665C52.5362 272.263 48.9292 268.414 48.4775 268.616C47.9692 268.843 53.1805 275.262 53.727 275.774C54.742 276.723 56.0211 277.51 56.9628 278.517C57.9962 279.624 57.7356 281.152 57.8325 282.714C58.1894 288.457 58.7958 294.148 59.5717 299.844C49.3036 299.928 42.6412 289.627 38.4268 281.718C35.3896 276.017 33.618 269.621 32.4905 263.277C30.9855 254.81 30.8982 246.024 31.129 237.424C31.3979 227.404 33.5478 217.599 37.2256 208.201C39.1491 203.286 41.7514 198.607 44.4975 194.085C45.8388 191.876 47.3353 189.871 49.2676 188.111C50.139 187.318 51.0789 186.605 52.0557 185.944C52.7979 185.442 54.1069 183.959 54.86 183.851C60.9892 182.917 66.2125 183.591 71.4798 186.833C76.4661 189.901 80.6979 194.344 84.0554 199.058C87.7939 204.308 90.6766 209.998 92.2837 216.246C93.51 221.013 94.1486 225.939 94.7663 230.824C96.9634 248.196 96.1537 268.238 85.285 283.174C81.7671 288.009 77.2251 291.949 72.2097 295.205C71.0279 295.972 69.843 296.729 68.5896 297.377C67.7447 297.815 64.6371 298.515 64.1773 299.17C63.5469 300.067 64.3545 303.195 64.4517 304.417C65.1913 313.702 66.2724 322.943 67.6219 332.151C69.0579 341.948 71.0372 351.602 73.3865 361.209C74.3859 365.295 75.4003 369.367 76.5268 373.42C76.7885 374.364 78.171 377.08 77.6582 378.246C77.334 378.984 76.4729 379.127 75.8782 378.668C74.844 377.87 74.4642 374.559 74.0866 373.321",
    fill: "#E03E3E"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_dd)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 206,
    transform: "matrix(-1 0 0 1 206 206)",
    fill: "#ECD189"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 181,
    height: 244,
    rx: 8,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 84 85)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.396,
    y: 172,
    width: 109.325,
    height: 7,
    rx: 3.5,
    transform: "rotate(45 244.396 172)",
    fill: "#EBECED"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 116.947,
    height: 7,
    rx: 3.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 172.051 172)",
    fill: "#EBECED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.274 188.39C313.848 192.146 307.534 193.961 304.57 193.221C297.139 191.363 296.455 165.004 302.205 154.612C307.955 144.22 337.514 139.691 339.004 160.28C339.521 167.425 336.427 173.802 331.856 179.006L340.055 216.057H316.241L320.274 188.39Z",
    fill: "#F0D4C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.688 183.642C336.677 170.749 345.192 161.96 343.891 156.198C342.591 150.435 336.959 149.03 336.959 149.03C336.959 149.03 334.047 137.606 318.172 139.311C302.297 141.017 292.608 147.41 296.792 161.476C300.638 161.476 305.282 160.127 311.702 162.438C314.758 163.538 316.074 169.259 316.074 169.259H318.975C318.975 169.259 323.199 162.469 327.305 164.269C331.411 166.069 329.172 173.012 329.172 173.012L330.601 183.642H333.688Z",
    fill: "#A26837"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.35371,
    ry: 1.96966,
    transform: "matrix(-1 0 0 1 302.121 170.493)",
    fill: "#222432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.722 167.859C304.375 167.74 306.746 170.137 306.601 170.297C306.455 170.456 304.301 169.096 302.813 169.046C301.639 169.007 300.771 169.545 300.608 169.249C300.496 169.046 301.471 167.949 302.722 167.859Z",
    fill: "#2E2232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.342 164.59C305.227 164.621 307.674 167.032 307.525 167.199C307.376 167.366 305.024 165.88 303.342 165.706C302.015 165.568 301.009 166.225 300.826 165.706C300.437 164.605 301.918 164.567 303.342 164.59Z",
    fill: "#191847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.851 184.615C303.274 185.226 301.88 186.338 300.914 185.902",
    stroke: "#222432",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 166.319,
    height: 7,
    rx: 3.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 319.051 90)",
    fill: "#EBECED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.6895,
    y: 90,
    width: 166.317,
    height: 7,
    rx: 3.5,
    transform: "rotate(45 93.6895 90)",
    fill: "#EBECED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.99 295.914L312.016 418.319L285.769 508.538H266.626L294.517 295.914H347.99Z",
    fill: "#0285BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.614 295.914C358.446 359.003 361.284 393.413 362.157 399.145C363.031 404.877 376.241 441.341 401.787 508.538H381.956C349.433 444.074 331.279 407.61 327.491 399.145C323.704 390.68 312.016 356.27 294.412 295.914H357.614Z",
    fill: "#00A9F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.521 307.217L260.629 280.629L269.965 296.292L240.736 313.001C233.407 324.195 229.103 329.032 227.823 327.511C226.744 326.229 227.239 324.824 227.694 323.529C228.049 322.521 228.38 321.58 227.925 320.817C226.887 319.074 221.018 320.072 215.491 321.25C209.964 322.428 211.243 319.796 212.418 318.422C217.641 314.334 224.343 310.599 232.521 307.217ZM398.201 345.846C395.293 340.126 385.391 284.379 385.391 284.379L364.655 284.458C364.655 284.458 383.86 344.571 385.391 348.249C387.379 353.027 384.002 359.969 381.712 364.676C381.357 365.404 381.029 366.079 380.751 366.684C383.928 368.063 385.455 366.396 387.064 364.639C388.882 362.655 390.805 360.555 395.333 362.597C397.083 363.387 398.738 364.32 400.355 365.231C405.942 368.38 411.073 371.272 418.055 367.095C419.161 366.433 420.374 363.94 417.444 361.992C410.143 357.138 399.622 348.642 398.201 345.846Z",
    fill: "#F0D4C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.468 200.017L317.888 198.59C303.116 234.371 277.325 266.882 240.516 296.124L268.331 328.89C305.136 287.253 327.823 244.296 326.468 200.017Z",
    fill: "#191847"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.871 304.566H287.468C287.468 304.566 314.019 241.97 314.019 198.216L337.066 194.887C355.179 223.132 360.294 257.909 363.871 304.566Z",
    fill: "#F4DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.602 336.315C390.246 244.912 337.574 194.887 337.574 194.887L337.556 194.902C337.553 194.897 337.55 194.892 337.547 194.887H336.043C333.342 194.977 327.817 195.212 327.817 195.212L322.248 210.643C321.364 238.864 311.928 324.391 311.928 324.391H361.938C361.853 328.312 361.665 332.289 361.362 336.315H398.602Z",
    fill: "#2F3676"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361.928 324.767C362.327 307.692 360.765 291.658 358.159 277.148C356.796 294.366 353.946 315.083 347.996 324.767H361.928Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.861 294.945L326.165 283.812V294.945H350.861Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd",
    x: -6,
    y: -6,
    width: 432,
    height: 432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 412,
    height: 412,
    rx: 206,
    transform: "matrix(-1 0 0 1 412 0)",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSales);
export default __webpack_public_path__ + "static/media/email-sales.53f2cfdaf2817c2859f528d7049d76c8.svg";
export { ForwardRef as ReactComponent };